import React from 'react';
import { useRadioGroupState } from '@react-stately/radio';
import { useRadioGroup } from '@react-aria/radio';
import { omit } from '../../utils/index.js';
import { getDescription } from '../form-state/form-state-utils.js';
import { RadioGroupContext } from './radio-group-context.component.js';
import { RadioGroupElement, RadioGroupButtonsContainerElement, } from './radio-group.styles.js';
export const RadioGroup = React.forwardRef(({ children, dataAutomation = 'radio-group', lang, className, style, description, variant = 'standard', ...props }, forwardedRef) => {
    const orientation = props.orientation || (variant === 'chips' ? 'horizontal' : 'vertical');
    const state = useRadioGroupState({
        ...props,
        description: typeof description === 'function' ? undefined : description,
    });
    const { radioGroupProps, labelProps, errorMessageProps, descriptionProps } = useRadioGroup({
        ...props,
        orientation,
        description: typeof description === 'function' ? undefined : description,
    }, state);
    const radioGroupElementProps = {
        ...omit(radioGroupProps, 'onChange', 'onFocus', 'onBlur'),
        onBlur: (e) => {
            props.onBlur?.(e);
        },
    };
    return (React.createElement(RadioGroupContext.Provider, { value: { state, variant } },
        React.createElement(RadioGroupElement, { ...radioGroupElementProps, containerRef: forwardedRef, dataAutomation: dataAutomation, lang: lang, className: className, style: style, isRequired: props.isRequired, label: {
                id: labelProps.id,
                hiddenLabel: props.hiddenLabel,
                children: props.label,
            }, error: {
                id: errorMessageProps.id,
                message: props.errorMessage,
            }, description: {
                id: descriptionProps.id,
                message: getDescription(description),
            } },
            React.createElement(RadioGroupButtonsContainerElement, { hiddenLabel: props.hiddenLabel, label: props.label, errorMessage: props.errorMessage, description: description, orientation: orientation, variant: variant }, children))));
});
//# sourceMappingURL=radio-group.component.js.map